import { render, staticRenderFns } from "./ProposalGrid.vue?vue&type=template&id=b400adb2"
import script from "./ProposalGrid.vue?vue&type=script&lang=js"
export * from "./ProposalGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports